import { ContentService } from '@common/services/content.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export class ItemsList {

    id: string;
    phase: string;

    constructor(id: string, phase: string = null) {
        this.id = id;
        this.phase = phase;
    }

    public getHeader(content: ContentService): Observable<string> {
        return content.value(this.id);
    }

    public getItemKeys(content: ContentService): Observable<string[]> {
        return content.get(this.id).pipe(
            map(list => {
                if (list && list.value) {
                    return list.value.itemKeys;
                }
            }));
    }
}
